import { Component, input, InputSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { SelectButtonModule } from 'primeng/selectbutton';

const STATE_OPTIONS = {
  day: 'day',
  month: 'month',
} as const;

type STATE_OPTION = (typeof STATE_OPTIONS)[keyof typeof STATE_OPTIONS];

@Component({
  selector: 'app-payment-card',
  imports: [SkeletonModule, SelectButtonModule, FormsModule],
  templateUrl: './payment-card.html',
  styleUrl: './payment-card.css',
})
export class PaymentCard {
  public loading: InputSignal<boolean> = input<boolean>(false);

  public descriptionLight: InputSignal<string | null> = input<string | null>(null);
  public dayValue: InputSignal<string | null> = input<string | null>(null);
  public monthValue: InputSignal<string | null> = input<string | null>(null);

  protected stateOptionsEnum = STATE_OPTIONS;
  protected stateOptions: { label: string; value: STATE_OPTION }[] = [
    { label: 'Dia', value: STATE_OPTIONS.day },
    { label: 'Mês', value: STATE_OPTIONS.month },
  ];
  protected selectedState: STATE_OPTION = STATE_OPTIONS.day;

  protected onStateChange(state: STATE_OPTION) {
    this.selectedState = state;
  }
}
